import { useState, useEffect } from 'react';
import Header from '../directives/header';
import {
  Container,
  Row,
  Col,
  Tab,
  Nav,
  Card,
  Button,
  Form,
} from 'react-bootstrap';
import Footer from '../directives/footer';
import { useAsyncError } from 'react-router-dom';
import { submitInquiryAction } from '../../apis/apiAction';
import { Toaster, toast } from 'react-hot-toast';

const Contact = () => {
  const [positionClass, setPositionClass] = useState('relative');
  const [form, setForm] = useState({
    inquiryType: '',
    Name: '',
    email: '',
    phoneNo: '',
    message: '',
  });

  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, options, selectedIndex } = e.target;
    setForm({
      ...form,
      [name]: name === 'inquiryType' ? options[selectedIndex].text : value,
    });
  };

  const validateForm = async () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!form.inquiryType) {
      newErrors.inquiryType = 'Select inquiry type';
    }

    if (!form.Name) {
      newErrors.Name = 'Name is required';
    }

    if (!form.email) {
      newErrors.email = 'Email is required';
    } else if (!emailRegex.test(form.email)) {
      newErrors.email = 'Enter a valid email';
    }

    if (!form.phoneNo) {
      newErrors.phoneNo = 'Phone number is required';
    }

    if (!form.message) {
      newErrors.message = 'Meassage is required';
    }
    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleClose = () => {
    setForm({ inquiryType: '', Name: '', email: '', phoneNo: '', message: '' });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (await validateForm()) {
      let res = await submitInquiryAction(form);
      if (res.status) {
        handleClose();
        toast.success(res.message);
      } else {
        handleClose();
        toast.error(res.message);
      }
    } else {
      toast.error('Please check the validations required.');
    }
  };
  useEffect(() => {
    const updatePosition = () => {
      setPositionClass(window.innerWidth >= 992 ? 'absolute' : 'relative mb-5');
    };

    updatePosition(); // Set initial state
    window.addEventListener('resize', updatePosition);

    return () => window.removeEventListener('resize', updatePosition);
  }, []);

  return (
    <>
      <Header />
      <Toaster />
      <div
        className="subheader"
        style={{ background: 'url(assets/images/contact.svg)' }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              <h2 className="fw-bold text-white">
                Get in Touch with Unitronix Corp
              </h2>
              <p>
                We’re here to answer your questions and help you explore
                investment opportunities in blockchain, tokenized finance, and
                decentralized investments.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <section className="contactForm ">
        <Container>
          <Row>
            <Col lg={12} className="mb-4">
              <div className="bg-darkblue">
                <Card className="lightBlueCard rounded-5 overflow-hidden p-3 pb-0">
                  <Card.Body className="pb-0">
                    <Row className="contactContent ">
                      <Col lg={6} className="position-relative z-1">
                        <div>
                          <div className="mb-4">
                            <h2 className="text-white fw-semibold mb-0">
                              Get in Touch
                            </h2>
                            <p>
                              Want to get in touch? We'd love to hear from you.
                            </p>
                          </div>
                          <div
                            className={`position-${positionClass} contactImg bottom-0`}
                          >
                            <img
                              src="assets/images/contactGirl.svg"
                              width={'90%'}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col lg={6} className="position-relative z-1">
                        <div className="">
                          <Form>
                            <p
                              style={{
                                textAlign: 'right',
                                fontSize: '12px',
                                fontStyle: 'italic',
                                marginTop: '-10px',
                              }}
                            >
                              Fields marked with * are compulsory
                            </p>
                            <Form.Group
                              className="mb-4"
                              controlId="formBasicEmail"
                            >
                              <Form.Label>Inquiry Type *</Form.Label>
                              <Form.Select
                                name="inquiryType"
                                value={form.inquiryType}
                                onChange={handleInputChange}
                                aria-label="Default select example"
                              >
                                <option>Select an option</option>
                                <option>Investor Inquiry</option>
                                <option>Shareholder Inquiry</option>
                                <option>General Inquiry</option>
                                <option>Partnership Opportunities</option>
                              </Form.Select>
                            </Form.Group>
                            <Form.Group
                              className="mb-4"
                              controlId="formBasicPassword"
                            >
                              <Form.Label>Name *</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Name"
                                name="Name"
                                value={form.Name}
                                onChange={handleInputChange}
                                isInvalid={!!errors.Name}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.Name}
                              </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                              className="mb-4"
                              controlId="formBasicPassword"
                            >
                              <Form.Label>Email*</Form.Label>
                              <Form.Control
                                type="email"
                                placeholder="Enter Email"
                                name="email"
                                value={form.email}
                                onChange={handleInputChange}
                                isInvalid={!!errors.email}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.email}
                              </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                              className="mb-4"
                              controlId="formBasicPassword"
                            >
                              <Form.Label>Phone Number</Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Phone Number"
                                name="phoneNo"
                                value={form.phoneNo}
                                onChange={handleInputChange}
                                isInvalid={!!errors.phoneNo}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.phoneNo}
                              </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group
                              className="mb-4 pb-1"
                              controlId="formBasicPassword"
                            >
                              <Form.Label>Message*</Form.Label>
                              <Form.Control
                                type="text"
                                as={'textarea'}
                                placeholder="Message"
                                name="message"
                                value={form.message}
                                onChange={handleInputChange}
                                isInvalid={!!errors.message}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.message}
                              </Form.Control.Feedback>
                            </Form.Group>

                            <Button
                              variant="primary"
                              type="submit"
                              className="w-100 mb-4"
                              onClick={(e) => handleSubmit(e)}
                            >
                              Submit
                            </Button>
                          </Form>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                  <div>
                    <div className="bgleft position-absolute top-0 bottom-0 start-0">
                      <img src="assets/images/shape/shapesphere.svg" />
                    </div>
                    <div className="particleImg d-flex h-100 align-items-center">
                      <img src="assets/images/particle.gif" />
                    </div>
                  </div>
                </Card>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default Contact;
